const regionDisplayOptions = [
  { value: 'state', label: 'States' },
  { value: 'metro', label: 'States + Metro Areas' },
  { value: 'zip3', label: 'States + Zip 3' }   
]

export default regionDisplayOptions
